/* 🤖 this file was generated by svg-to-ts */
export const siriusChats: {
  name: 'chats';
  data: string;
} = {
  name: 'chats',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M21.75 9a1.5 1.5 0 0 0-1.5-1.5h-3v-3a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v12a.74.74 0 0 0 .431.675.722.722 0 0 0 .788-.094l3.281-2.643v2.812a1.5 1.5 0 0 0 1.5 1.5h8.775l3.506 2.831c.132.11.298.17.469.169a.75.75 0 0 0 .75-.75V9ZM6.244 12.919 3.75 14.925V4.5h12v8.25H6.713a.722.722 0 0 0-.47.169Zm11.522 4.5a.74.74 0 0 0-.478-.169H8.25v-3h7.5a1.5 1.5 0 0 0 1.5-1.5V9h3v10.425l-2.484-2.006Z" fill="currentColor"/></svg>`
};
